// utils/calendarioUtils.js
// Presentación de los registros de horas en el calendario (12.3.a):
// color por proyecto y etiqueta compacta de una sola línea.

// Paleta acotada para elegir el color de un proyecto. Todos cumplen
// contraste AA con el texto que les asigna colorTexto.
export const PALETA_PROYECTOS = [
  "#c62828", // rojo
  "#ad1457", // rosa
  "#6a1b9a", // violeta
  "#283593", // índigo
  "#1565c0", // azul
  "#00838f", // cian
  "#2e7d32", // verde
  "#ef6c00", // naranja
  "#fdd835", // amarillo
  "#5d4037", // marrón
];

// Proyecto sin color: el verde que usaba el calendario (emerald-500).
export const COLOR_POR_DEFECTO = "#10b981";

const HEX = /^#[0-9a-f]{6}$/i;
const LARGO_NOMBRE = 10;

export function formatoHoras(horas) {
  return Number(horas).toLocaleString("es-UY", { maximumFractionDigits: 2 });
}

export function etiquetaCompacta(nombre, horas) {
  const corto = (nombre || "").slice(0, LARGO_NOMBRE);
  return [corto, formatoHoras(horas)].filter(Boolean).join(" ");
}

// Luminancia relativa WCAG de un #RRGGBB.
function luminancia(hex) {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// Texto blanco o negro, el que más contraste tenga sobre el fondo.
export function colorTexto(fondo) {
  const l = luminancia(fondo);
  return (l + 0.05) / 0.05 >= 1.05 / (l + 0.05) ? "#000000" : "#ffffff";
}

export function estiloRegistro(color) {
  const fondo = HEX.test(color || "") ? color : COLOR_POR_DEFECTO;
  return { backgroundColor: fondo, color: colorTexto(fondo) };
}

export function tooltipHora({ presupuesto, tarea, horas, comentarios }) {
  return [presupuesto, `${tarea} · ${formatoHoras(horas)} hs`, comentarios]
    .filter(Boolean)
    .join("\n");
}

// 12.3.b (opción 2 del cliente): el color del proyecto; si no tiene, el de su
// obra; si tampoco, el verde de siempre (en listados y calendario).
export function colorEfectivo(proyecto) {
  const valido = (color) => (HEX.test(color || "") ? color : null);
  return valido(proyecto?.color) || valido(proyecto?.obra?.color) || COLOR_POR_DEFECTO;
}
